import Button from "components/semantic/Button";
import React, { FC, useEffect, useState } from "react";
import lockImg from "assets/icons/lock.svg";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "utils/hooks";
import { checkCouponThunk, transactionThunk } from "store/thunk/kyp.thunk";
import { GoEyeClosed } from "react-icons/go";
import { SlEye } from "react-icons/sl";

interface PaymentCardProps {
  feeAmount: any;
}

const PaymentCard: FC<PaymentCardProps> = ({ feeAmount }) => {
  const param: any = useParams();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isCouponLoading = useAppSelector((state) => state.rootReducer.kypSlice.loadingCoupon);
  const [couponCode, setCouponCode] = useState<any>();
  const [isValidCoupon, setValidCoupon] = useState(false);
  const [paymentAmount, setPaymentAmount] = useState("");
  const [showCoupon, setShowCoupon] = useState(false);

  useEffect(() => {
    if (feeAmount) setPaymentAmount(feeAmount);
  }, [feeAmount]);

  async function displayRazorpay(data: any) {
    const options: any = {
      key: process.env.REACT_APP_RAZORPAY_KEY,
      amount: data?.amount || 50000,
      name: "Insurance Samadhan",
      description: "Pay for Policies " + param.policyId,
      image: "https://storage.googleapis.com/insa-partners-prod/staticImage/paymentlogo.png",
      prefill: {
        email: data.email,
        contact: data.phone
      },
      notes: [data.txnId],
      theme: {
        color: "#000000"
      },
      handler: async function () {
        try {
          navigate(`/kyp/payment-success/${param.policyId}`);
        } catch (error) {
          // console.log("Something went wrong");
        }
      }
    };
    const paymentObject: any = new (window as any).Razorpay(options);
    paymentObject.open();
  }

  const handlePayment = async () => {
    const payload: { policyId: string; coupon?: string } = {
      coupon: isValidCoupon ? couponCode : "",
      policyId: param.policyId
    };

    dispatch(transactionThunk(payload))
      .unwrap()
      .then((data) => {
        if (data?.data?.payStatus) {
          displayRazorpay(data?.data || {});
          return;
        } else {
          navigate(`/kyp/payment-success/${param.policyId}`);
        }
      });
    return;
  };

  const submitCouponHandler = () => {
    dispatch(checkCouponThunk({ coupon: couponCode, policyId: param.policyId }))
      .unwrap()
      .then((data) => {
        if (data?.success && data?.data?.couponExist) {
          setValidCoupon(true);
          setPaymentAmount(data?.data?.feeAmount);
        }
      });
  };
  const handleRemoveCoupon = () => {
    setValidCoupon(false);
    setCouponCode("");
    setPaymentAmount(feeAmount);
  };
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center z-50">
      <img src={lockImg} className="-mb-6" />
      <div className="bg-overlay-gradient border-4 rounded-[10px] border-[#0000001A] p-5">
        <p className="font-extrabold text-xl text-center">Please Pay Rs {paymentAmount || "-"}</p>
        <p className="font-semibold text-center text-sm mt-1">to view complete KYP analysis</p>
        <p className="text-xs font-semibold text-center mt-3 border-b-[1px] pb-2 border-[#00000026] text-[#00000099]">ENTER YOUR COUPON CODE</p>
        <div className="w-full my-3">
          <div className="flex items-center border rounded bg-white h-8 overflow-hidden">
            <div className="flex items-center flex-1 px-2">
              <input
                type={showCoupon ? "text" : "password"}
                value={couponCode}
                onChange={(e) => {
                  setCouponCode(e.target.value.toUpperCase());
                  setShowCoupon(false);
                }}
                placeholder="Enter coupon code"
                disabled={isValidCoupon}
                className="flex-1 text-sm font-semibold text-gray-700 focus:outline-none disabled:bg-gray-100"
              />

              {!isValidCoupon && couponCode && (
                <button type="button" onClick={() => setShowCoupon((prev) => !prev)} className="text-xs text-gray-500">
                  {showCoupon ? <SlEye /> : <GoEyeClosed />}
                </button>
              )}
            </div>
            <button
              type="button"
              onClick={submitCouponHandler}
              disabled={!couponCode || isValidCoupon}
              className={`h-full px-3 text-sm font-bold transition
        ${isValidCoupon ? "text-green-600 bg-green-50 cursor-default" : couponCode ? "text-[#2F9D7F] hover:bg-[#2F9D7F]/10" : "text-gray-400 cursor-not-allowed"}
      `}
            >
              {isValidCoupon ? "APPLIED" : "APPLY"}
            </button>
          </div>

          {/* Remove Coupon */}
          {isValidCoupon && (
            <button type="button" onClick={handleRemoveCoupon} className="mt-1 ml-1 text-xs text-red-500 font-semibold">
              Remove Coupon
            </button>
          )}
        </div>
        <div className="w-full ">
          <Button title="CONTINUE" isLoading={isCouponLoading} onClick={handlePayment} className={`${isCouponLoading && "opacity-50 pointer-events-none"}`} />
        </div>
      </div>
    </div>
  );
};

export default PaymentCard;
